import { useQuery } from '@tanstack/react-query';
import { subscriptionApi } from '../services/apiService';
import { useTimeFrame } from '../contexts/TimeFrameContext';
import {
  OrderTypeSubscriptionData,
  ShiftSubscriptionData,
  SubscriptionTrendData,
  TimePeriod
} from '../types/api';

export const SUBSCRIPTION_QUERY_KEYS = {
  OVERALL_TREND: 'subscriptionOverallTrend',
  BY_SHIFT: 'subscriptionByShift',
  BY_ORDER_TYPE: 'subscriptionByOrderType',
};

export function useSubscriptionOverallTrend(branchId: number | undefined, customTimeRange?: TimePeriod) {
  const { apiTimeFrame } = useTimeFrame();
  const timeRange = customTimeRange || apiTimeFrame;

  return useQuery<SubscriptionTrendData[]>({
    queryKey: [SUBSCRIPTION_QUERY_KEYS.OVERALL_TREND, branchId, timeRange],
    queryFn: async () => {
      if (!branchId) throw new Error('Branch ID is required');
      const response = await subscriptionApi.getOverallTrend(branchId, timeRange);
      return response.data;
    },
    enabled: !!branchId,
  });
}

export function useSubscriptionByShift(branchId: number | undefined, customTimeRange?: TimePeriod) {
  const { apiTimeFrame } = useTimeFrame();
  const timeRange = customTimeRange || apiTimeFrame;

  return useQuery<ShiftSubscriptionData[]>({
    queryKey: [SUBSCRIPTION_QUERY_KEYS.BY_SHIFT, branchId, timeRange],
    queryFn: async () => {
      if (!branchId) throw new Error('Branch ID is required');
      const response = await subscriptionApi.getByShift(branchId, timeRange);
      return response.data;
    },
    enabled: !!branchId,
  });
}

export function useSubscriptionByOrderType(branchId: number | undefined, customTimeRange?: TimePeriod) {
  const { apiTimeFrame } = useTimeFrame();
  const timeRange = customTimeRange || apiTimeFrame;

  return useQuery<OrderTypeSubscriptionData[]>({
    queryKey: [SUBSCRIPTION_QUERY_KEYS.BY_ORDER_TYPE, branchId, timeRange],
    queryFn: async () => {
      if (!branchId) throw new Error('Branch ID is required');
      const response = await subscriptionApi.getByOrderType(branchId, timeRange);
      return response.data;
    },
    enabled: !!branchId,
  });
}
